import React from 'react';
import LineGraph from '../../../../../components/linegraph';
import { getDateRange, getTrendIndicator } from '../../../../../utils/performanceUtils';
import { KPI_DECIMAL_PLACES } from '../../../../../constants/constants';
import { useAppSelector } from '../../../../../redux/hooks';
import { selectOverallPerformanceData } from '../../../../../redux/PerformanceReducer/Overall/overallSlice';


/**
 * AceRewardsGraphs component displays Ace Rewards performance line graphs
 * Accesses performance data directly from Redux store
 */
const AceRewardsGraphs: React.FC = (): JSX.Element => {
  const data = useAppSelector(selectOverallPerformanceData);

  const rewardsIssued = data?.RDI;
  const rewardsRedeemed = data?.RDR;
  const rewardsOutstanding = data?.RDO;

  return (
    <>
      <LineGraph
        title={rewardsIssued?.title}
        mainValue={rewardsIssued?.currentYtdAmount}
        format={rewardsIssued?.format}
        decimalPlaces={KPI_DECIMAL_PLACES[rewardsIssued?.kpiCode ?? '']}
        datasets={rewardsIssued?.datasets}
        trendIndicator={getTrendIndicator(rewardsIssued)}
        dateRange={getDateRange(rewardsIssued)}
      />
      <LineGraph
        title={rewardsRedeemed?.title}
        mainValue={rewardsRedeemed?.currentYtdAmount}
        format={rewardsRedeemed?.format}
        decimalPlaces={KPI_DECIMAL_PLACES[rewardsRedeemed?.kpiCode ?? '']}
        datasets={rewardsRedeemed?.datasets}
        trendIndicator={getTrendIndicator(rewardsRedeemed)}
        dateRange={getDateRange(rewardsRedeemed)}
      />
      <LineGraph
        title={rewardsOutstanding?.title}
        mainValue={rewardsOutstanding?.currentYtdAmount}
        format={rewardsOutstanding?.format}
        decimalPlaces={KPI_DECIMAL_PLACES[rewardsOutstanding?.kpiCode ?? '']}
        datasets={rewardsOutstanding?.datasets}
        trendIndicator={getTrendIndicator(rewardsOutstanding)}
        dateRange={getDateRange(rewardsOutstanding)}
      />
    </>
  );
};

export default AceRewardsGraphs;
